<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
  // overflow-x: hidden;
}

.el-dialog.organization-dialog {
  height: 80vh !important;
  min-height: 80vh !important;
  max-height: 80vh !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.el-dialog.organization-dialog .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 10px !important;
  overflow-y: auto;
}

/* s3-layer 的所属组织/工会树选择框同样保留 10px 标题下间距。 */
.layui-layer-page .layui-layer-content .el-tree {
  margin-top: 10px;
}

.el-dialog.organization-dialog .el-dialog__footer {
  flex: 0 0 auto;
  margin-top: 0;
}

.el-dialog.organization-dialog .el-button,
.el-dialog.organization-dialog .organization-confirm-button {
  width: auto !important;
  height: 32px !important;
  font-size: 14px !important;
}
</style>
